/**
 * batch-67 middelen-inname - een middel heeft een omschrijving en een kenmerk
 * (serienummer, IMEI, kenteken, pasnummer). De omschrijving noemt dat kenmerk vaak
 * al ("SN-123 · Boormachine Makita", "AB-123-C · Volkswagen Transporter"). Wie de
 * twee naast elkaar toont, gebruikt deze helpers, zodat hetzelfde kenmerk niet twee
 * keer in beeld staat.
 */

/** Het kenmerk als los gegeven, of `null` als het ontbreekt of al in de omschrijving staat. */
export function losKenmerk(omschrijving: string | null | undefined, kenmerk: string | null | undefined): string | null {
  const k = kenmerk?.trim()
  if (!k) return null
  return (omschrijving ?? '').toLowerCase().includes(k.toLowerCase()) ? null : k
}

/** "Boormachine Makita (SN-123)", zonder herhaling als de omschrijving het kenmerk al noemt. */
export function metKenmerk(omschrijving: string, kenmerk: string | null | undefined): string {
  const k = losKenmerk(omschrijving, kenmerk)
  return k ? `${omschrijving} (${k})` : omschrijving
}
